import { GetStaticPropsContext } from 'next';
import { createClient } from 'prismicio';

import {
  buildNavigation,
  getLeafSectionFromPath
} from 'components/PRISMIC/PrismicNavigation/util';
import { getAllSections } from 'components/pages/prismic/utils';
import {
  buildStaticPropsFromSlices,
  Page as PrismicPage
} from 'pages/pages/[uid]';

import { PageDocument } from 'prismic-types';
import { FilledContentRelationshipField } from '@prismicio/client';

export default PrismicPage;

type PageParams = { prismicPath: string[] };

export async function getStaticProps({
  previewData
}: GetStaticPropsContext<PageParams>) {
  const client = createClient({ previewData });
  const path = ['series'];

  const sections = await getAllSections(client);
  const leafSection = getLeafSectionFromPath(path, sections);
  return getPageDocument(leafSection, client, path, sections);
}

const getPageDocument = async (leafSection, client, path, sections) => {
  let page: PageDocument | undefined = undefined;
  const defaultPageUid = leafSection?.data?.default_page?.data?.uid;

  if (defaultPageUid) {
    page = await client.getByUID('page', defaultPageUid);
  }

  if (!page) {
    const slug = path[path.length - 1];
    try {
      page = await client.getByUID('page', slug || '');
    } catch {
      return {
        redirect: {
          destination: '/r_error/',
          permanent: false
        }
      };
    }
  }

  const navigation = buildNavigation(
    (page.data.section as FilledContentRelationshipField).id,
    sections,
    page.uid
  );

  return {
    props: {
      page,
      navigation,
      staticProps: await buildStaticPropsFromSlices(page)
    },
    revalidate: 60
  };
};
